import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import EToll from "../component/eToll/ETollTable";
const RfidCardPage = () => {
  return (
    <Box>
      <Routes>
        <Route path="/" element={<EToll />} />
      </Routes>
    </Box>
  );
};

export default RfidCardPage;
